const light = {
  type: "light",
  primary: {
    main: "#50D492",
    active: "rgba(0,0,0,0.6)",
    dark: "#389466",
    contrastText: "#ffffff",
  },
  secondary: {
    main: "#243665",
  },
  error: {
    main: "#F44336",
  },
  text: {
    secondary: "rgba(0,0,0,0.6)",
    grey: "#9E9E9E",
    grey600: "#757575",
    primary: "rgba(0,0,0,0.87)",
    disabled: "#00000061",
  },
  action: {
    active: "rgba(0, 0, 0, 0.54)",
  },
};

export default light;
